import React, { FC, useCallback, useEffect } from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	siteSurveysRestCrudThunksForBuyer,
	siteSurveysRestCrudThunksForSupplier,
} from '../../thunks/site_surveys_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import queryString from 'querystring';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { updateNavbarState } from '../../actions/navbar_actions';
import { getLinkWIthBackLinkParams, goBackLink } from '../../utils/HistoryUtils';
import { withUserType } from '../withUserType';
import DeleteConfirmButton from '../delete_pop_confirm/DeletePopConfirm';
import { ROLE_TYPES } from '../../utils/DataConstants';

require('./SiteSurveysDetailPage.less');

const SiteSurveysDetailPage: FC<any> = ({
	getSiteSurvey,
	deleteSiteSurvey,
	location,
	match,
	updateNavbar,
	history,
	siteSurvey,
	userType,
	siteSurveysFetching,
	childRoutes,
	companyConfig,
}): React.ReactElement => {
	const siteSurveyId = match.params.id;

	useEffect(() => {
		getSiteSurvey(siteSurveyId).then((siteSurvey) => {
			let searchString = location.search;
			if (searchString[0] === '?') {
				searchString = searchString.slice(1);
			}
			const queryParams = queryString.parse(searchString);
			if (queryParams.backlinkParams) {
				updateNavbar(
					'Back To Site Surveys',
					`/${userType}/siteSurveys/byTitle/${nullSafeGet(
						'title',
						siteSurvey
					)}/template/${nullSafeGet('siteSurveyTemplateId', siteSurvey)}/locations?${
						queryParams.backlinkParams
					}`
				);
			}
		});
	}, []);

	const handleTabChange = useCallback(
		(key) => {
			history.push(`/${userType}/siteSurveys/detail/${siteSurveyId}/${key}`);
		},
		[history, siteSurveyId, userType]
	);

	const handleDelete = useCallback(() => {
		deleteSiteSurvey(siteSurvey).then(() => {
			history.push(goBackLink(location, `/${userType}/siteSurveys/overview/all`));
		});
	}, [deleteSiteSurvey, history, location, siteSurvey, userType]);

	const handleEdit = useCallback(() => {
		history.push(
			getLinkWIthBackLinkParams(
				location,
				'Back to Site Survey Detail',
				`/${userType}/siteSurveys/overview/edit/${siteSurvey.id}`
			)
		);
	}, [history, location, siteSurvey.id, userType]);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history]
	);

	const tabs = [
		{
			key: 'details',
			name: 'Overview',
		},
		{
			key: 'walkthroughs',
			name: 'Walkthroughs',
		},
	];
	return (
		<div className="siteSurveysDetailPage">
			<DetailPageHeader
				exactPath={`/${userType}/siteSurveys/detail/:id`}
				redirectPath={`/${userType}/siteSurveys/detail/${siteSurveyId}/details`}
				backLinkText={'Back to site surveys'}
				backLinkTo={`/${userType}/siteSurveys/byTitle/${nullSafeGet(
					'title',
					siteSurvey
				)}/template/${nullSafeGet('siteSurveyTemplateId', siteSurvey)}/locations`}
				title={siteSurveysFetching ? null : siteSurvey.title}
				subtitle={
					<div className="siteSurveysDetailPage__subtitleRow">
						<div className="siteSurveysDetailPage__subtitle">
							{nullSafeGet('location.name', siteSurvey)}
						</div>
					</div>
				}
				actions={[
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SITE_SURVEYS}>
						<Button key={1} ghost={true} onClick={handleEdit} style={{ marginRight: 16 }}>
							Edit
						</Button>
						<DeleteConfirmButton
							onConfirm={handleDelete}
							title={'Are you sure you want to delete this site survey?'}
						>
							<Button key={1} ghost={true}>
								Delete
							</Button>
						</DeleteConfirmButton>
					</AccessPermissionChecker>,
				]}
				tabs={tabs}
				backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
				handleTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
			/>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	siteSurveysFetching: state.site_surveys.fetching,
	siteSurvey: state.site_surveys.detail,
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config,
	location: ownProps.location,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getSiteSurvey: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveysRestCrudThunksForSupplier.readOne(id)
				: siteSurveysRestCrudThunksForBuyer.readOne(id)
		),
	deleteSiteSurvey: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? siteSurveysRestCrudThunksForSupplier.delete(entity, 'id', null, true)
				: siteSurveysRestCrudThunksForBuyer.delete(entity, 'id', null, true)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(SiteSurveysDetailPage as any) as any)
);
